import PropTypes from 'prop-types';
import React from 'react';
import I18n from 'i18n-js';
import { Tabs } from 'grab-ui';
import cx from 'classnames';
import star from 'public/icons/star.svg';
import starUnselected from 'public/icons/star-unselect.svg';
import { processTimeSlot } from 'helper/anytime-booking';
import { PriceSurgeIcon } from 'components/v2/anytime-booking/common/price-surge-icon';

import styles from './styles.less';

export const bestOptionsKey = '__BEST__';

export const PickUpTimeSlotUI = ({
  timeSlot,
  onTimeSlotClick,
  pickUpRange,
  selected,
  fare,
}) => (
  <a
    key={timeSlot.from || 'now'}
    onClick={timeSlot.available ? onTimeSlotClick(timeSlot) : undefined}
    className={cx(styles.timeSlot, {
      [styles.selected]: selected,
      [styles.disabled]: !timeSlot.available,
    })}
  >
    <span>{pickUpRange}</span>
    {fare && (
      <span className={styles.fareContainer}>
        <span className={styles.fare}>{fare} </span>
        <PriceSurgeIcon priceSurgeInfo={timeSlot} />
      </span>
    )}
  </a>
);

PickUpTimeSlotUI.defaultProps = {
  selected: false,
  fare: '',
};

PickUpTimeSlotUI.propTypes = {
  timeSlot: PropTypes.shape({}).isRequired,
  onTimeSlotClick: PropTypes.func.isRequired,
  pickUpRange: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  fare: PropTypes.string,
};

export const PickUpTimeSectionUI = ({
  timeSlotsInTabs,
  selectedTab,
  onSelectTab,
}) => (
  <div className={styles.section}>
    <div className={styles.sectionTitle}>
      {I18n.t('v2.anytimeBooking.pickUpTimeSectionTitle')}
    </div>
    <div className={styles.timeSlotSelector}>
      <Tabs activeKey={selectedTab} onChange={onSelectTab}>
        {Object.entries(timeSlotsInTabs).map(
          ([tabKey, { dateLabels, timeSlotDoms }]) => (
            <Tabs.TabPane
              key={tabKey}
              tab={
                <div
                  className={cx(styles.dateTab, {
                    [styles.selected]: selectedTab === tabKey,
                  })}
                >
                  <div className={styles.weekday}>
                    {tabKey === bestOptionsKey
                      ? I18n.t('v2.anytimeBooking.bestOptionsTab')
                      : dateLabels.weekday}
                  </div>
                  <div className={styles.date}>
                    {tabKey === bestOptionsKey ? (
                      selectedTab === tabKey ? (
                        <img className={styles.icon} src={star} alt="" />
                      ) : (
                        <img
                          className={styles.icon}
                          src={starUnselected}
                          alt=""
                        />
                      )
                    ) : (
                      dateLabels.date
                    )}
                  </div>
                </div>
              }
            >
              <div className={styles.timeSlots}>{timeSlotDoms}</div>
            </Tabs.TabPane>
          ),
        )}
      </Tabs>
    </div>
  </div>
);

PickUpTimeSectionUI.defaultProps = {
  selectedTab: undefined,
};

PickUpTimeSectionUI.propTypes = {
  timeSlotsInTabs: PropTypes.shape({}).isRequired,
  onSelectTab: PropTypes.func.isRequired,
  selectedTab: PropTypes.string,
};

const isTimeSlotSelected = (timeSlot, selectedTimeSlot) => {
  const { from, to } = timeSlot || {};
  if (from && to) {
    return (
      selectedTimeSlot &&
      selectedTimeSlot.from === from &&
      selectedTimeSlot.to === to
    );
  }
  return selectedTimeSlot === null; // now
};

export const generateTimeSlotInDate = (
  timeSlot,
  pickUpSLA,
  isBestOption,
  countryCode,
  selectedTimeSlot,
  sameDayNowSlotPrice,
  timeSlotsInTabs,
  onTimeSlotClick,
) => {
  const selected = isTimeSlotSelected(timeSlot, selectedTimeSlot);
  const { dateKey, dateLabels, pickUpRange } = processTimeSlot({
    timeSlot,
    pickUpSLA,
    isBestOption,
    countryCode,
  });
  const fare =
    timeSlot.fare ||
    (!timeSlot.from && !timeSlot.to ? sameDayNowSlotPrice : undefined);
  const tabKey = isBestOption ? bestOptionsKey : dateKey;
  if (!timeSlotsInTabs[tabKey]) {
    timeSlotsInTabs[tabKey] = {
      dateLabels,
      timeSlots: [],
      timeSlotDoms: [],
    };
  }
  timeSlotsInTabs[tabKey].timeSlots.push(timeSlot);
  timeSlotsInTabs[tabKey].timeSlotDoms.push(
    <PickUpTimeSlotUI
      key={timeSlot.from || 'now'}
      timeSlot={timeSlot}
      onTimeSlotClick={onTimeSlotClick}
      pickUpRange={pickUpRange}
      selected={selected}
      fare={fare || ''}
    />,
  );
};
